<div class="profile-page bg-secondary">
  <main class="pt-4">
    <div class="container wow fadeIn">
      <div class="row">
        <div class="col-md-12 mb-2">
          <h2 class="my-5 h2 text-center">Checkout</h2>
          <h4 class="d-flex justify-content-between align-items-center mb-3">
            <span class="text-muted">Order Summary</span>
          </h4>

          <ul class="list-group mb-3 z-depth-1">
            <li class="list-group-item d-flex justify-content-between lh-condensed">
              <div>
                <h5 class="my-0">{{ groceryModel.description }}</h5>
              </div>
            </li>
            <li class="list-group-item d-flex justify-content-between">
              <span>Pick Up Name</span>
              <strong>{{ groceryModel.collectorName }}</strong>
            </li>
            <li class="list-group-item d-flex justify-content-between">
              <span>Pick Up Surname</span>
              <strong>{{ groceryModel.collectorSurname }}</strong>
            </li>
            <li class="list-group-item d-flex justify-content-between">
              <span>Pick Up Number</span>
              <strong>{{ groceryModel.collectorNumber }}</strong>
            </li>
            <li class="list-group-item d-flex justify-content-between">
              <span>Amount To Pay</span>
              <strong>ZAR {{ groceryModel.totalAmount }}</strong>
            </li>
          </ul>

          <div>
            <h4 v-if="showPaymentMethods" class="d-flex justify-content-between align-items-center mb-3">
              <span class="text-muted">Payment Methods</span>
            </h4>
            <ul v-if="showPaymentMethods" class="list-group mb-3 z-depth-1">
              <li class="list-group-item d-flex">
                <div class="col-md-12">
                  <span class="text-muted">
                    <input type="radio" name="paymentMethod" value="wallet" v-model="paymentMethod" />
                  </span>&nbsp;&nbsp;
                  Umbai wallet &nbsp;&nbsp;
                  <i class="fa fa-money fa-1x"></i>
                </div>
              </li>
              <li class="list-group-item d-flex">
                <div class="col-md-12">
                  <span class="text-muted">
                    <input type="radio" name="paymentMethod" value="#cc" v-model="paymentMethod" />
                  </span>&nbsp;&nbsp;
                  Credit/Cheque card &nbsp;&nbsp;
                  <img class="img-fluid" src="img/visa.svg" height="24" alt="visa" /> &nbsp;
                  <img class="img-fluid" src="img/mastercard.svg" height="24" alt="mastercard" />
                </div>
              </li>
              <li class="list-group-item d-flex">
                <div class="col-md-12">
                  <span class="text-muted">
                    <input type="radio" name="paymentMethod" value="#ef" v-model="paymentMethod" />
                  </span>&nbsp;&nbsp;
                  InstantEft &nbsp;&nbsp;
                  <img class="img-fluid" src="img/instanteft.svg" height="24" alt="instanteft" />
                </div>
              </li>
            </ul>
            <div>
              <button class="btn btn-primary btn-block" type="button" @click="initiatePayment">Pay</button>
            </div>
          </div>

          <div class="vld-parent">
            <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
          </div>

          <form :action="GetPaymentURL()" method="post" id="payfast">
            <input type="hidden" name="merchant_id" :value="payment.merchantId" />
            <input type="hidden" name="merchant_key" :value="payment.merchantKey" />
            <input type="hidden" name="return_url" :value="payment.returnUrl" />
            <input type="hidden" name="cancel_url" :value="payment.cancelUrl" />
            <input type="hidden" name="notify_url" :value="payment.notifyUrl" />
            <input type="hidden" name="m_payment_id" :value="payment.mPaymentId" />
            <input type="hidden" name="amount" :value="payment.totalAmount" />
            <input type="hidden" name="item_name" :value="payment.itemName" />
            <input type="hidden" name="item_description" :value="payment.itemDescription" />
            <input type="hidden" name="signature" :value="payment.signature" />
          </form>
        </div>
      </div>
    </div>
  </main>
</div>
